import { useContext } from 'react'
import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import { SavedIcon } from '../../../StateManagment/SavedIcon'
import useSharedCollection from '../../../firebase/useSharedCollection'
import Location from '../../../hooks/Location'
import { db } from '../../../firebase/config'
import { LOCATION_KEY, sortLocations } from '../../../helpers/locations/locationFilter'
import hasLocationFilter from '../../../helpers/dashboardHelpers/hasLocationFilter'
import ReadOnlyGuard from '../../common/ReadOnlyGuard'

/**
 * De sectie 'Locatie' op het tabblad Gegevens van een huishouden.
 *
 * Locaties zijn één instelling die huishoudens en deelnemers delen: een
 * fixbrigade heeft fixers én huishoudens in dezelfde wijk. Het veld is daarom
 * `LocationID`, net als op `Personas` en `Tasks`, en de waarde is de Firestore-
 * **docid** van het locatiedocument — niet het `ID`-veld.
 * AI-CONTEXT: See docs/features/huishouden-locaties.md
 *
 * Verschijnt pas vanaf twee locaties. Bij nul of één valt er niets te kiezen en
 * is een keuzelijst die niets doet verwarrender dan geen keuzelijst.
 *
 * Niet te verwarren met `Adresses.Location`, dat pal hiernaast leeft en de
 * PDOK-geocode van het adres is (ADR-023).
 *
 * @returns {JSX.Element|null}
 */
const HouseholdLocationCard = () => {
    const [, setSaved] = useContext(SavedIcon)
    const adressId = Location()[3]

    const locations = useSharedCollection('Locations')
    const adressList = useFirestoreGeneral('Adresses', 'ID', adressId || '')
    const adress = Array.isArray(adressList) && adressList.length > 0 ? adressList[0] : null

    // Zolang het huishouden nog onderweg is geen keuzelijst: die zou op
    // '-- Geen locatie --' staan terwijl we het niet weten, en een keuze schrijft
    // dan iets weg dat de gebruiker nooit koos.
    // AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
    if (!adress) return null
    if (!hasLocationFilter(locations)) return null

    const locationHandler = async (e) => {
        await db.collection('Adresses').doc(adress.docid).update({
            [LOCATION_KEY]: e.target.value,
        })
        // Terugkoppeling zoals elders: zonder opslaanknop is dit het enige
        // teken dat de keuze bewaard is.
        setSaved('flex')
    }

    return (
        <div className="dashboard-container adress-household-location">
            <h3>Locatie</h3>
            <ReadOnlyGuard edit="addresses.edit">
                <select
                    value={adress[LOCATION_KEY] || ''}
                    onChange={locationHandler}
                    aria-label="Locatie van dit huishouden"
                >
                    <option value="">-- Geen locatie --</option>
                    {sortLocations(locations).map((loc) => (
                        <option key={loc.docid} value={loc.docid}>
                            {loc.Title || 'Naamloze locatie'}
                        </option>
                    ))}
                </select>
            </ReadOnlyGuard>
        </div>
    )
}

export default HouseholdLocationCard
